export default __webpack_public_path__ + "static/media/bot.8c7d8d8b.svg";